import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import { MainContent } from './styles';

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <MainContent
        component="main"
        sx={{
          flexGrow: 1,
          p: 2, // Reduzido de 3 para 2
          pl: 1, // Padding left menor ainda
          mt: isMobile ? '56px' : 0,
          width: '100%',
          minHeight: '100vh',
          backgroundColor: 'background.default'
        }}
      >
        {children}
      </MainContent>
    </Box>
  );
};

export default Layout;